import { useEffect, useRef } from 'react';

const SITE_KEY = '0x4AAAAAACsliLsyf34Fam0q';
const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

export default function Turnstile({ onToken, reset }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const isFirstReset = useRef(true);

  useEffect(() => {
    let cancelled = false;

    function render() {
      if (cancelled || !containerRef.current || !window.turnstile) return;
      if (widgetIdRef.current !== null) {
        try { window.turnstile.remove(widgetIdRef.current); } catch (_) {}
      }
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: SITE_KEY,
        theme: 'dark',
        size: 'flexible',
        callback: (token) => onToken(token),
        'expired-callback': () => onToken(null),
        'error-callback': () => onToken(null),
      });
    }

    if (window.turnstile) {
      render();
    } else {
      const existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
      if (!existing) {
        const script = document.createElement('script');
        script.src = SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.onload = () => { if (!cancelled) render(); };
        document.head.appendChild(script);
      } else {
        const timer = setInterval(() => {
          if (window.turnstile) { clearInterval(timer); if (!cancelled) render(); }
        }, 50);
        return () => { cancelled = true; clearInterval(timer); };
      }
    }

    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Reset widget when `reset` toggle changes (skip initial mount)
  useEffect(() => {
    if (isFirstReset.current) { isFirstReset.current = false; return; }
    if (widgetIdRef.current !== null && window.turnstile) {
      window.turnstile.reset(widgetIdRef.current);
    }
    onToken(null);
  }, [reset]); // eslint-disable-line react-hooks/exhaustive-deps

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (widgetIdRef.current !== null && window.turnstile) {
        try { window.turnstile.remove(widgetIdRef.current); } catch (_) {}
        widgetIdRef.current = null;
      }
    };
  }, []);

  return <div ref={containerRef} />;
}
